import PropTypes from 'prop-types';

import { ImageOverlayForm } from 'src/components/ImageOverlayForm';
import { GENERATION_IMPROVE_MODE } from 'src/data/generation';

import { InternalSubmenuListItem } from '../InternalSubmenuListItem';

import styles from './ChangeImageOverlayItem.module.css';

const propTypes = {
  className: PropTypes.string,
  ImageOverlayProps: PropTypes.shape(ImageOverlayForm.propTypes).isRequired,
  hasOverlayText: PropTypes.bool,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};

const defaultProps = {
  className: '',
  hasOverlayText: false,
  selected: false,
  disabled: false,
};

export const ChangeImageOverlayItem = ({
  className,
  ImageOverlayProps,
  hasOverlayText,
  selected,
  disabled,
}) => {
  return (
    <InternalSubmenuListItem
      className={className}
      improveMode={GENERATION_IMPROVE_MODE.changeImageOverlay}
      labelOverride={hasOverlayText ? 'Edit overlay text' : 'Add overlay text'}
      selected={selected}
      disabled={disabled}
    >
      {({ closeMenu }) => (
        <ImageOverlayForm
          className={styles.form}
          {...ImageOverlayProps}
          onSubmit={() => {
            closeMenu();
            ImageOverlayProps.onSubmit();
          }}
          onCancel={closeMenu}
        />
      )}
    </InternalSubmenuListItem>
  );
};

ChangeImageOverlayItem.displayName = 'ChangeImageOverlayItem';
ChangeImageOverlayItem.propTypes = propTypes;
ChangeImageOverlayItem.defaultProps = defaultProps;
